import type { BomboraGlobal } from './globals'

// Mirrors the third-party provider setup baked into the internal kitchensink's index.html
// (Chili-Piper/frontend apps/web-data-snippet/src/kitchensink/index.html): the real Bombora
// tag loader (command queue + vi.ml314.com script) and a 6sense localStorage mock written
// after a 2s delay — simulating a 6sense visitor detection event mid-session.

const installBomboraTag = (): void => {
  if (window._bmb) return

  const bmb: BomboraGlobal = Object.assign(
    (...args: unknown[]): void => {
      if (bmb.x) bmb.x(...args)
      else bmb.q.push(args)
    },
    { q: [] as unknown[][] }
  )
  window._bmb = bmb

  const script = document.createElement('script')
  script.async = true
  const fingerprint = window.localStorage.getItem('_ccmaid') ?? ''
  script.src = `https://vi.ml314.com/get?eid=94461&tk=iXulAcV2b2bWzOhs45eZzWMosYCOhuzCocoNzP1y2yhKw3d&fp=${fingerprint}`
  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }
}

const SIXSENSE_COMPANY_DETAILS = {
  company: {
    company_match: 'Match',
    additional_comment: 'Company name or domain match was found',
    companyId: 'j776sdf7sdfh766777dsf',
    domain: 'g.ucla.edu',
    name: 'UCLA',
    region: 'Northern America',
    country: 'United States',
    state: 'California',
    city: 'Los Angeles',
    industry: 'Education',
    country_iso_code: 'US',
    address: '308 Charles E. Young Drive North A210 Fowler Building/Box 951510',
    zip: '90095',
    phone: '(310) 825-4321',
    employee_range: '10,000+',
    revenue_range: '$5B+',
    employee_count: '22000',
    annual_revenue: '7449000000',
    is_blacklisted: false,
    is_6qa: true,
    geoIP_country: 'United States',
    geoIP_state: 'California',
    geoIP_city: 'San Jose',
    state_code: 'CA',
    industry_v2: [
      {
        industry: 'Education',
        subindustry: 'Colleges & Universities',
      },
    ],
    sic_description: '',
    sic: '',
    naics: '6113',
    naics_description: 'Colleges, Universities, and Professional Schools',
  },
  scores: [
    {
      is_6qa: true,
      product: '6sense',
      product_display_name: '6sense',
      intent_score: 63,
      buying_stage: 'Consideration',
      profile_score: 9,
      profile_fit: 'Weak',
    },
  ],
  segments: {
    ids: [4713, 28237, 218915, 53685],
    names: [
      'Net New Logo Website Engagement Last 30 Days',
      '6s for 6s: Keyword_Sales Intelligence',
      'Cvent: Researching Virtual Events',
      'EY - Enterprise Accounts (DemandGen)',
    ],
    list: [
      {
        name: 'Net New Logo Website Engagement Last 30 Days',
        id: 4713,
      },
      {
        name: '6s for 6s: Keyword_Sales Intelligence',
        id: 28237,
      },
      {
        name: 'Cvent: Researching Virtual Events',
        id: 218915,
      },
      {
        name: 'EY - Enterprise Accounts (DemandGen)',
        id: 53685,
      },
    ],
  },
  confidence: 'Very High',
}

const install6SenseMock = (): void => {
  window._6si = {}
  window.setTimeout(() => {
    window.localStorage.setItem('_6senseCompanyDetails', JSON.stringify(SIXSENSE_COMPANY_DETAILS))
  }, 2000)
}

installBomboraTag()
install6SenseMock()
